export default __webpack_public_path__ + "static/form-input-masks-do-1453371b124c1f359b788fab24a62926b5ca52e76e3422ecdcaba17ce625ec07.png";